import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ViewModelService } from './view-model.service';

/**
 * Route Guard for Step One Confirm
 * Ensures user has completed the initial Step One form before accessing the confirmation page
 * Checks that tenancy data exists (assetId is required)
 */
export const stepOneConfirmGuard: CanActivateFn = (route, state) => {
   const vm = inject(ViewModelService);
   const router = inject(Router);

   // Check if we have the required tenancy data from Step One
   if (!vm.tenancy.assetId) {
      console.log('[IDV Guard] Step One Confirm access denied - no tenancy data. Redirecting to stepone.');
      router.navigate(['stepone']);
      return false;
   }

   return true;
};

/**
 * Route Guard for Step Two
 * Ensures user has completed Step One before accessing Step Two
 * Checks that tenancy data exists (assetId is required for API calls)
 */
export const stepTwoGuard: CanActivateFn = (route, state) => {
   const vm = inject(ViewModelService);
   const router = inject(Router);

   // Check if we have the required tenancy data from Step One
   if (!vm.tenancy.assetId) {
      console.log('[IDV Guard] Step Two access denied - no tenancy data. Redirecting to stepone.');
      router.navigate(['stepone']);
      return false;
   }

   return true;
};

/**
 * Route Guard for Step Three
 * Ensures user has completed Steps One and Two before accessing Step Three
 * Checks that tenancy data AND selected contact exist
 */
export const stepThreeGuard: CanActivateFn = (route, state) => {
   const vm = inject(ViewModelService);
   const router = inject(Router);

   // Check if we have tenancy data from Step One
   if (!vm.tenancy.assetId) {
      console.log('[IDV Guard] Step Three access denied - no tenancy data. Redirecting to stepone.');
      router.navigate(['stepone']);
      return false;
   }

   // Check if we have selected contact from Step Two
   if (!vm.selectedContactId) {
      console.log('[IDV Guard] Step Three access denied - no contact selected. Redirecting to stepone.');
      router.navigate(['stepone']);
      return false;
   }

   return true;
};

/**
 * Route Guard for Stepthree Confirm
 * Ensures the user arrived here via a successful Step Three submission.
 * Prevents direct navigation to the confirmation/polling page.
 */
export const stepthreeConfirmGuard: CanActivateFn = (route, state) => {
   const vm = inject(ViewModelService);
   const router = inject(Router);

   if (!vm.resumeUrl) {
      console.log('[IDV Guard] Step 3 Confirm access denied - no resumeUrl. Redirecting to stepone.');
      router.navigate(['stepone']);
      return false;
   }

   return true;
};
